module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/hub/hub.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/hub/hub.png
// module id = 576
// module chunks = 0